import { StatRow } from 'oas';

export const getUniqueAthleteCount = (stat: StatRow) => {
    const activityIds = stat['activity_average_array'] ?? []; // Just activity ids
    const activityAthleteIds = stat['activity_array'] ?? []; // activity athlete ids (activity_id + athlete_id)
    const athletes = new Set<string>();

    for (const item of activityAthleteIds) {
        const activity = activityIds?.find((id: string) => item.startsWith(id));
        if (activity) {
            athletes.add(item.slice(activity.length));
        }
    }

    return athletes.size;
};
